/*
 * @Description: 
 * @Autor: Ray7hw
 * @LastEditTime: 2020-10-10 10:47:26
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    num: 1,
    // userName: localStorage.getItem('userName') ? localStorage.getItem('userName') : '',
  },
  mutations: {
    add(state, e) {
      state.num = e
    },
    set_userName(state, userName) {
      state.userName = userName
      localStorage.setItem('userName', userName);
    },

  },
  actions: {

  },
  getters: {
    num(state) {
      return state.num
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js